const Loader = () => (
    <>
        <div className="pageloader"></div>
        <div className="infraloader is-active"></div>
    </>
)

export default Loader